/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `wide` - 와이드 샷
 * `extreme_wide` - 익스트림 와이드
 * `medium` - 미디엄 샷
 * `close_up` - 클로즈업
 * `extreme_close_up` - 익스트림 클로즈업
 * `aerial` - 에어리얼 샷
 * `low_angle` - 로우앵글
 * `high_angle` - 하이앵글
 * `over_the_shoulder` - 오버더숄더
 */
export type ShotTypeEnum = (typeof ShotTypeEnum)[keyof typeof ShotTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShotTypeEnum = {
  wide: "wide",
  extreme_wide: "extreme_wide",
  medium: "medium",
  close_up: "close_up",
  extreme_close_up: "extreme_close_up",
  aerial: "aerial",
  low_angle: "low_angle",
  high_angle: "high_angle",
  over_the_shoulder: "over_the_shoulder",
} as const;
